import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { eventEmitter } from '@app/shared/utils/event-emitter';
import { ApplicationHttpClient } from '@app/core/http';


@Injectable({ providedIn: 'root' })
export class AccountService {

  constructor(private http: ApplicationHttpClient) {
  }

  public getList(filters = {}) {
    return this.http.getList('/api/app/tenant-user', {
      params: {
        ...filters
      }
    });
  }

  public getDetailById(id: string) {
    return this.http.get(`/api/app/tenant-user/${ id }`, {
    });
  }

  public create(body, options = {}) {
    return this.http.post('/api/app/tenant-user', body, options);
  }

  public update(id, body, options = {}) {
    return this.http.post(`/api/app/tenant-user/${ id }`, body, options);
  }

  public delete(id) {
    return this.http.delete(`/api/app/tenant-user/${ id }`);
  }

  public getAccountOfCompany(companyId: string) {
    return this.http.get(`/accounts/account-default/${ companyId }`, {
    });
  }

  public createUserAgency(body, options = {}) {
    return this.http.post('/accounts/agency-account', body, options);
  }

  public createUserCustomer(body, options = {}) {
    return this.http.post('/accounts/customer-account', body, options);
  }

  public sendEmail(body, options = {}) {
    return this.http.post('/accounts/send-mail-account', body, options);
  }
 
   
}
